App.controller('ResponseSearchCtrl', ResponseSearchCtrl);

ResponseSearchCtrl.$inject = [
    'surveys'
];

function ResponseSearchCtrl(surveys) {
    var vm = this;

    vm.search = '';
    vm.surveys = surveys;
}